import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaPhoneAlt, FaEnvelope, FaChevronDown } from 'react-icons/fa';
import { MdHotel } from 'react-icons/md';
import './Header.css';

const navLinks = [
  { path: '/', label: 'Home' },
  { path: '/about', label: 'About' },
  {
    label: 'Rooms',
    children: [
      { path: '/rooms', label: 'All Rooms & Suites' },
      { path: '/rooms/deluxe-king-room', label: 'Deluxe King Room' },
      { path: '/rooms/junior-suite', label: 'Junior Suite' },
      { path: '/rooms/presidential-suite', label: 'Presidential Suite' },
    ],
  },
  { path: '/gallery', label: 'Gallery' },
  {
    label: 'Explore',
    children: [
      { path: '/services', label: 'Services & Amenities' },
      { path: '/offers', label: 'Special Offers' },
      { path: '/testimonials', label: 'Testimonials' },
      { path: '/faq', label: 'FAQ' },
    ],
  },
  { path: '/contact', label: 'Contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();
  const dropdownRef = useRef(null);
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    setActiveDropdown(null);
  }, [location]);

  useEffect(() => {
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const headerClass = `header ${scrolled || !isHome ? 'header--solid' : 'header--transparent'} ${menuOpen ? 'header--open' : ''}`;

  return (
    <header className={headerClass}>
      <div className="header-top">
        <div className="container header-top-inner">
          <div className="header-contacts">
            <a href="tel:+18005551234"><FaPhoneAlt /> +1 (800) 555-1234</a>
            <a href="mailto:sales@rstechservices.in"><FaEnvelope /> sales@rstechservices.in</a>
          </div>
          <div className="header-tagline">Luxury Reimagined · Est. 1995</div>
        </div>
      </div>

      <div className="header-main">
        <div className="container header-main-inner">
          <Link to="/" className="header-logo">
            <MdHotel className="logo-icon" />
            <div className="logo-text">
              <span className="logo-name">Grand Luxe</span>
              <span className="logo-subtitle">Hotel & Spa</span>
            </div>
          </Link>

          <nav className={`header-nav ${menuOpen ? 'header-nav--open' : ''}`} ref={dropdownRef}>
            {navLinks.map((link, i) =>
              link.children ? (
                <div
                  key={i}
                  className={`nav-item nav-item--dropdown ${activeDropdown === i ? 'active' : ''}`}
                  onMouseEnter={() => window.innerWidth > 900 && setActiveDropdown(i)}
                  onMouseLeave={() => window.innerWidth > 900 && setActiveDropdown(null)}
                >
                  <button
                    className="nav-link nav-link--dropdown"
                    onClick={() => setActiveDropdown(activeDropdown === i ? null : i)}
                  >
                    {link.label} <FaChevronDown className="dropdown-arrow" />
                  </button>
                  <div className="dropdown-menu">
                    {link.children.map((child, j) => (
                      <NavLink key={j} to={child.path} className="dropdown-item">
                        {child.label}
                      </NavLink>
                    ))}
                  </div>
                </div>
              ) : (
                <NavLink
                  key={i}
                  to={link.path}
                  className={({ isActive }) => `nav-link ${isActive ? 'nav-link--active' : ''}`}
                  end={link.path === '/'}
                >
                  {link.label}
                </NavLink>
              )
            )}
          </nav>

          <div className="header-actions">
            <Link to="/booking" className="btn btn-primary header-book-btn">
              Book Now
            </Link>
            <button
              className="header-hamburger"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              {menuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
